import { useNavigate } from "@tanstack/react-router"
import type { ColumnDef, ColumnSort, OnChangeFn, Row, SortingState } from "@tanstack/react-table"
import { getCoreRowModel } from "@tanstack/react-table"
import type { FC, Ref } from "react"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import { type WarehouseAreaOutputList } from "@/graphql/codegen/graphql"

interface WarehousesTableProps {
  data: WarehouseAreaOutputList[]
  fetching: boolean
  columns: ColumnDef<WarehouseAreaOutputList>[]
  sorting: ColumnSort[]
  error?: Error
  tableContainerRef?: Ref<HTMLDivElement>
  onSortingChange: OnChangeFn<SortingState>
  onScroll: () => void
}

export const WarehousesTable: FC<WarehousesTableProps> = ({
  data,
  fetching,
  columns,
  sorting,
  error,
  tableContainerRef,
  onSortingChange,
  onScroll,
}) => {
  const navigate = useNavigate()

  const onRowClick = (row: Row<WarehouseAreaOutputList>) => {
    navigate({ from: "/app/admin/warehouses", to: `${row.original.warehouseAreaId}` })
  }

  return (
    <AerosBaseTable
      features={{
        table: {
          stickyHeader: true,
        },
        tanstackOptions: {
          data,
          columns,
          state: {
            sorting,
            isLoading: fetching,
          },
          onSortingChange,
          manualSorting: true,
          enableSorting: true,
          enableMultiSort: false,
          enableSortingRemoval: false,
          getCoreRowModel: getCoreRowModel(),
        },
      }}
      error={error}
      slotProps={{
        container: {
          ref: tableContainerRef,
          onScroll,
        },
        bodyRow: {
          className: "hover:bg-primary-100 cursor-pointer",
          onClick: (row) => {
            if ("original" in row) {
              onRowClick(row)
            }
          },
        },
      }}
      noDataMessage='No warehouses found'
    />
  )
}

export default WarehousesTable
